import type { Translations } from '../../../types'

const shopMediaMessages: Translations = {
  "shop.media.upload.imageFailed": "Upload immagine fallito",
  "shop.media.upload.invalidImage": "Carica un file immagine valido",
  "shop.media.upload.successOne": "Foto caricata",
  "shop.media.upload.successMany": "{{count}} foto caricate",
  "shop.media.library.loadError": "Errore caricamento media library",
}

export default shopMediaMessages
